import { render, staticRenderFns } from "./MessageNotification.vue?vue&type=template&id=4926da1a&"
import script from "./MessageNotification.vue?vue&type=script&lang=js&"
export * from "./MessageNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports